// src/components/Utils/ScrollToTop.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // "0, 0" instantly moves the window to the top-left corner
        window.scrollTo(0, 0);
    }, [pathname]); // Triggers every time the URL path changes

    return null; // This component renders nothing visually
};

export default ScrollToTop;